import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Install Drawings Upload service stores.
 *
 * Backed by the API service in `install/install-documents/`. Files themselves
 * live on azure_blob_storage (referenced by blobId); these rows are just the
 * metadata that lets the /install accordion list+filter them per project.
 *
 * The store stays on the plain ServiceStore (NOT OfflineServiceStore) — same
 * bug pattern that previously crashed `notifications`. Do not add
 * 'install-documents' to autoOfflineStores in ServiceStoreFactory.ts.
 */
export const installStores: ServiceStoreConfig[] = [
  {
    name: "install-documents",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    // Install Daily Report (added 2026-10-05). enableStorage is OFF: the
    // report is per-day and read a day at a time, and a ServiceStore's
    // entities collection never evicts — the 08-27 ghost-record shape would
    // mean yesterday's row showing up on today's screen. The screen reads
    // find() results directly, so there is nothing to cache.
    //
    // Stays on the plain ServiceStore. Do NOT add 'daily-reports' to
    // autoOfflineStores in ServiceStoreFactory.ts — same prohibition as
    // install-documents above.
    name: "daily-reports",
    options: {
      enableStorage: false,
      enableErrorNotifications: true,
    },
  },
]
